import { Action } from '@ngrx/store';
import { TechnicalError } from '@dch/products-business-logic';

export const GET_CLOUD_PRODUCT_PRICE = 'GET_CLOUD_PRODUCT_PRICE';
export const GET_CLOUD_PRODUCT_PRICE_SUCCESS =
  'GET_CLOUD_PRODUCT_PRICE_SUCCESS';
export const GET_CLOUD_PRODUCT_PRICE_FAILED = 'GET_CLOUD_PRODUCT_PRICE_FAILED';

export const GET_CLOUD_ACTIVATION_STATUS = 'GET_CLOUD_ACTIVATION_STATUS';
export const GET_CLOUD_ACTIVATION_STATUS_SUCCESS =
  'GET_CLOUD_ACTIVATION_STATUS_SUCCESS';
export const GET_CLOUD_ACTIVATION_STATUS_FAILED =
  'GET_CLOUD_ACTIVATION_STATUS_FAILED';
export const GET_CLOUD_ACTIVATION_STATUS_NO_CHANGE =
  'GET_CLOUD_ACTIVATION_STATUS_NO_CHANGE';

export const ACTIVATE_CLOUD_ACCOUNT = 'ACTIVATE_CLOUD_ACCOUNT';
export const ACTIVATE_CLOUD_ACCOUNT_SUCCESS = 'ACTIVATE_CLOUD_ACCOUNT_SUCCESS';
export const ACTIVATE_CLOUD_ACCOUNT_FAILED = 'ACTIVATE_CLOUD_ACCOUNT_FAILED';

export class GetCloudProductPrice implements Action {
  type = GET_CLOUD_PRODUCT_PRICE;

  constructor(public payload?: any) {}
}

export class GetCloudProductPriceSuccess implements Action {
  type = GET_CLOUD_PRODUCT_PRICE_SUCCESS;

  constructor(public payload: any) {}
}

export class GetCloudProductPriceFailed implements Action {
  type = GET_CLOUD_PRODUCT_PRICE_FAILED;

  constructor(public payload: TechnicalError) {}
}

export class GetCloudActivationStatus implements Action {
  type = GET_CLOUD_ACTIVATION_STATUS;

  constructor(public payload?: any) {}
}

export class GetCloudActivationStatusSuccess implements Action {
  type = GET_CLOUD_ACTIVATION_STATUS_SUCCESS;

  constructor(public payload: any) {}
}

export class GetCloudActivationStatusFailed implements Action {
  type = GET_CLOUD_ACTIVATION_STATUS_FAILED;

  constructor(public payload: TechnicalError) {}
}

export class GetCloudActivationStatusNoChange implements Action {
  type = GET_CLOUD_ACTIVATION_STATUS_NO_CHANGE;

  constructor() {}
}

export class ActivateCloudAccount implements Action {
  type = ACTIVATE_CLOUD_ACCOUNT;

  constructor(public payload?: any) {}
}

export class ActivateCloudAccountSuccess implements Action {
  type = ACTIVATE_CLOUD_ACCOUNT_SUCCESS;

  constructor(public payload: any) {}
}

export class ActivateCloudAccountFailed implements Action {
  type = ACTIVATE_CLOUD_ACCOUNT_FAILED;

  constructor(public payload: TechnicalError) {}
}

export type Actions =
  | GetCloudProductPrice
  | GetCloudProductPriceSuccess
  | GetCloudProductPriceFailed
  | GetCloudActivationStatus
  | GetCloudActivationStatusSuccess
  | GetCloudActivationStatusFailed
  | ActivateCloudAccount
  | ActivateCloudAccountSuccess
  | ActivateCloudAccountFailed;
